import { gql } from '@apollo/client'

export const FRAGMENT_REGISTRATION_BASE = gql`
  fragment RegistrationBase on Registration {
    id
  }
`
